import React from "react";
import { toast, } from "react-toastify"
import withStyles from "@material-ui/core/styles/withStyles";
import Contacts from "@material-ui/icons/Contacts";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import { fetchData } from '../../utils/handleApi'
// import { Switch, FormControlLabel, FormGroup, } from '@material-ui/core';

// const GreenSwitch = withStyles({
//   switchBase: {
//     color: "#04ab23",
//     '&$checked': {
//       color: "#04ab23",
//       '& + $bar': {
//         backgroundColor: "#04ab23",
//       },
//     },
//   },
//   checked: {},
//   bar: {},
// })(Switch);
class EditVendorForm extends React.Component {

  state = {
      nameState: "",
      phone_numberState: "",
      streetState: "",
      cityState: "",
      stateState: "",
      zipState: "",

      name: "",
      phone_number: "",
      street: "",
      city: "",
      state: "",
      zip: "",
      // is_notification: false,
      
      required: "",
      requiredState: "",
      typeEmail: "",
      typeEmailState: "",
      number: "",
      numberState: "",
      url: "",
      urlState: "",
      equalTo: "",
      whichEqualTo: "",
      equalToState: "",
      
      minLength: "",
      minLengthState: "",
      maxLength: "",
      maxLengthState: "",
      range: "",
      rangeState: "",
      minValue: "",
      minValueState: "",
      maxValue: "",
      maxValueState: "",
     
      isFormSubmitting: false,
    };

  componentDidMount(){
    document.getElementById("phone_number").min = "0";
    document.getElementById("zip").min = "0";

    let { vendorId } = this.props.match.params;
    fetchData('vendor/all', 'get').then(data => {
      if(data.err){
        return toast.error('Some error happened!')
      }
      let currentVendor = data.filter((vendor) => vendor.id === +vendorId)[0]
      this.setState({
        name: currentVendor.name,
        nameState: 'success',
        street:  currentVendor.street,
        streetState: 'success',
        city: currentVendor.city,
        cityState: 'success',
        state: currentVendor.state,
        stateState: 'success',
        zip: currentVendor.zip,
        zipState: 'success',
        phone_number: currentVendor.phone_number,
        phone_numberState: 'success',
        // is_notification: currentVendor.is_notification === "true" ? true : false,
      })
    })
  }
  
  verifyEmail(value) {
    let emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }
  
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  
  compare(string1, string2) {
    if (string1 === string2) {
      return true;
    }
    return false;
  }
  
  verifyNumber(value) {
    let numberRex = new RegExp("^[0-9]*$");
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  }
  
  verifyUrl(value) {
    try {
      new URL(value);
      return true;
    } catch (_) {
      return false;
    }
  }

  change(event, stateName, type, stateNameEqualTo, maxValue) {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 1)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "equalTo":
        if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "checkbox":
        if (event.target.checked) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "number":
        if (this.verifyNumber(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "length":
        if (this.verifyLength((event.target.value).replace(/ /g,""), stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } 
        else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "max-length":
        if (!this.verifyLength(event.target.value, stateNameEqualTo + 1)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "url":
        if (this.verifyUrl(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "min-value":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo
        ) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "max-value":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value <= stateNameEqualTo
        ) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "range":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo &&
          event.target.value <= maxValue
        ) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      default:
        break;
    }
    switch (type) {
      case "checkbox":
        this.setState({ [stateName]: event.target.checked });
        break;
      default:
        this.setState({ [stateName]: event.target.value });
        break;
    }
  }

  editVendor = () => {
    let isValid = true
    const { name, street, city, state, zip, phone_number, is_notification } = this.state;
    if (name.trim() === "") {
      this.setState({ nameState: "error" });
      isValid = false
    }
    if (street.trim() === "") {
      this.setState({ streetState: "error" });
      isValid = false
    }
    if (city.trim() === "" ) {
      this.setState({ cityState: "error" });
      isValid = false
    }
    if (state.trim() === "" ) {
      this.setState({ stateState: "error" });
      isValid = false
    }

    if(isValid){
      this.setState({ isFormSubmitting: true })
      const vendorBody = { name, street, city, state, zip, phone_number, is_notification }
      fetchData(`vendor/update?vendor_id=${this.props.match.params.vendorId}`, 'post', vendorBody)
      .then(data => {
        if(data.err){
          return toast.error(data.err.data.message ? 'Vendor already exists with that email id!' : 'Some error happened!', {
            onClose: () => this.setState({ isFormSubmitting: false })
          })
        }
        toast.success('Vendor Updated Successfully!', {
          onClose: () => this.props.history.goBack()
        })
      })
    }
  }

  disableHyphen=(e)=>{
    if(e.keyCode === 189){
        e.preventDefault();
    }
  }

  render() {
    const { nameState, name, phone_numberState, phone_number, streetState, street, cityState, city, stateState, state,
      zipState, zip, isFormSubmitting } = this.state;
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color="success">
                <Contacts />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Enter Vendor Details</h4>
              <Button 
                style={{
                  float: 'right',
                  backgroundColor: "rgb(4, 171, 35)"
                }}
                onClick={() => this.props.history.goBack()}
              >
                Back
              </Button>
            </CardHeader>
            <CardBody>
              <form>
                <CustomInput
                  success={nameState === "success"}
                  error={nameState === "error"}
                  labelText="Name *"
                  id="name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "name", "length", 1),
                    type: "text",
                    value: name
                  }}
                />
                <CustomInput
                  success={phone_numberState === "success"}
                  error={phone_numberState === "error"}
                  labelText="Phone Number *"
                  id="phone_number"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "phone_number", "length", 1),
                    type: "number",
                    min: 1,
                    value: phone_number,
                    onKeyDown: (e) => this.disableHyphen(e)
                  }}
                />
                <CustomInput
                  success={streetState === "success"}
                  error={streetState === "error"}
                  labelText="Street *"
                  id="street"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "street", "length", 1),
                    type: "text",
                    value: street
                  }}
                />
                <CustomInput
                  success={cityState === "success"}
                  error={cityState === "error"}
                  labelText="City *"
                  id="city"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "city", "length", 1),
                    type: "text",
                    value: city
                  }}
                />
                <CustomInput
                  success={stateState === "success"}
                  error={stateState === "error"}
                  labelText="State *"
                  id="state"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "state", "length", 1),
                    type: "text",
                    value: state
                  }}
                />
                <CustomInput
                  success={zipState === "success"}
                  error={zipState === "error"}
                  labelText="ZIP *"
                  id="zip"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "zip", "length", 1),
                    type: "number",
                    value: zip,
                    onKeyDown: (e) => this.disableHyphen(e)
                  }}
                />
                {/* <FormGroup row>
                  <FormControlLabel
                    control={
                      <GreenSwitch
                        checked={is_notification}
                        value={is_notification.toString()}
                        onChange={() => {
                          this.setState({ is_notification: !is_notification})
                        }}
                        id="is_notifcation"
                        name="is_notifcation"                      
                      />
                    }
                    label="Receive Email Notifications?"
                  />
                </FormGroup> */}
                <div className={classes.center}>
                  <Button 
                  disabled={isFormSubmitting} 
                  style={{backgroundColor: "rgb(4, 171, 35)"}} 
                  onClick={this.editVendor}>
                    Update Vendor
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(validationFormsStyle)(EditVendorForm);
